import React from "react";
import Image, { StaticImageData } from "next/image";
import { Images } from "../../assets/assets";

type AccordionProps = {
  selectedImage: string | StaticImageData | undefined;
};
export default function WhatShapeSideImage({ selectedImage }: AccordionProps) {
  return (
    <div className="w-full 2xl:w-[705px] 2xl:h-[700px] relative overflow-hidden rounded-none">
      <Image
        src={selectedImage || Images?.ourMission1}
        alt="What shapes Konstant"
        fill
        sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
        className="object-cover"
      />
    </div>
  );
}
